/**
 * «SIN DECIDIR», la tarjeta del panel. Cuenta dos cosas que esperan al autor:
 *
 *   · lo que le propusieron en el chat y no ha decidido (la bitácora), y
 *   · lo que las pasadas le dejaron en Word y aún no se ha leído (Fable, 26-sep).
 *
 * Callar lo segundo era decir «Sin decidir: 0» con 375 cambios de las pasadas sin contar. Se lee
 * solo cuando el autor guarda y cierra el documento; «Leerlo ahora» es para no esperar.
 */
import { useState } from "react";
import { deVueltaDeWord, miles } from "../api";
import { frasesDeVuelta, motivosDeEspera } from "../logica";
import type { Resumen } from "../api";

export default function SinDecidir({ dir, doc, resumen, alVerCuales, alLeido }: {
  dir: string; doc: string | null; resumen: Resumen | null; alVerCuales: () => void; alLeido: () => void;
}) {
  const [leyendo, setLeyendo] = useState(false);
  const [lectura, setLectura] = useState<{ ok: boolean; texto: string } | null>(null);
  const sinDecidir = resumen?.decisiones.sin_decidir ?? 0;
  const enWord = resumen?.en_word?.sin_leer ?? 0;
  const motivos = motivosDeEspera(resumen?.en_word?.versiones ?? []);

  async function leer() {
    if (!doc) return;
    setLeyendo(true); setLectura(null);
    try { setLectura({ ok: true, texto: frasesDeVuelta(await deVueltaDeWord(dir, doc)) }); alLeido(); }
    catch (e) { setLectura({ ok: false, texto: (e as Error).message }); }
    finally { setLeyendo(false); }
  }

  return (
    <section className="carta">
      <h2>Sin decidir<span className="sub">esperan por ti</span></h2>
      <div className="cifra"><b>{resumen ? sinDecidir : "—"}</b><span>propuestas</span></div>
      {sinDecidir > 0 && (
        <button className="btn fantasma" style={{ alignSelf: "flex-start" }} onClick={alVerCuales}>Ver cuáles</button>
      )}
      {enWord > 0 && (
        <>
          <p className="vacio">
            <b>{miles(enWord)} {enWord === 1 ? "cambio de tus pasadas espera" : "cambios de tus pasadas esperan"}</b> a que se lea lo que
            decidiste en Word.{motivos.length ? "" : " Se lee solo cuando guardas y cierras el documento."}
          </p>
          {motivos.map((m) => <p className="vacio" key={m}>{m}</p>)}
          <button className="btn fantasma" style={{ alignSelf: "flex-start" }} disabled={leyendo || !doc} onClick={leer}>
            {leyendo ? "Leyendo tus versiones…" : "Leerlo ahora"}
          </button>
        </>
      )}
      {lectura && <p className="vacio" style={lectura.ok ? undefined : { color: "var(--acc)" }}>{lectura.texto}</p>}
      {resumen && !sinDecidir && !enWord && !lectura && <p className="vacio">Todo lo que te han propuesto tiene una decisión tuya.</p>}
    </section>
  );
}
